import { makeAutoObservable } from 'mobx'
import { mx } from 'store/base/mx'

export class BoutiqueQrModalStore {
  readonly widget_user_id: string

  constructor(user_id: string) {
    makeAutoObservable(this)
    this.widget_user_id = user_id
  }
}

export const boutiqueQrModal = mx.ref<BoutiqueQrModalStore>()
